import React from "react";
import {ContentBox, Container} from "../../components/UI";

export default function PageNotFound() {
    return (
        <Container>
            <ContentBox>
                Page not found...
            </ContentBox>
        </Container>
    )
}